var map = {
	"./AXS.png": 1158,
	"./ENS.png": 1159,
	"./JPG.png": 1160,
	"./KEEP.png": 1161,
	"./SAND.png": 1162,
	"./SUSHI.png": 1163,
	"./WETH.png": 1164,
	"./ZZ.png": 1165,
	"./icETH.png": 1166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1157;